module.exports = __webpack_public_path__ + "media/store/images/logoIcon-98ed38a477518e3ebd8dcd0d8dd65234.svg";